import { configureStore } from '@reduxjs/toolkit'
import userReducers from './reducers/usersreducer'
import commonReducers from './reducers/commonreducer'

export default configureStore({
  reducer: {
    users: userReducers,
    common: commonReducers,
  },
})